exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-46b23b5d].image-upload .el-upload-list{display:none}[data-v-46b23b5d].image-upload .el-upload--text,[data-v-46b23b5d].image-upload .el-upload-dragger{width:292px;height:191px}[data-v-46b23b5d].image-upload .el-loading-mask{display:none}[data-v-46b23b5d].image-upload .el-upload-dragger:hover{border-color:#a28b77}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46b23b5d","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/common/upload-image.vue
// module id = 180
// module chunks = 1 5